<template>
  <div class="recordList">

    <TopTitle title="财务管理" />
    <div class="home-page-tab">
      <el-tabs v-model="tabIndex">
        <el-tab-pane label="充值记录" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 搜索 -->
    <div class="search-box">
      <el-form :inline="true">
        <el-form-item label="付款方式">
          <el-select v-model="search.payType" size="small" clearable filterable placeholder="付款方式" style="width: 220px;margin-right: 10px;">
            <el-option v-for="item in stateList.payType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票状态">
          <el-select v-model="search.invoiceStatus" size="small" filterable clearable placeholder="开票状态" style="width: 220px;margin-right: 10px;">
            <el-option v-for="item in stateList.payStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间:">
          <el-date-picker v-model="dateArr" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="empty">重置</el-button>
          <el-button type="primary" size="small" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-link class="export" icon="iconfont icon-daochujilu1" type="primary" @click="exporTables" :underline="false">导出表格</el-link>
    <el-link class="export" icon="iconfont icon-biaoji" type="primary" @click="handApplication" :underline="false">申请开票</el-link>

    <div class="list-tab-page">
      <div class="list-table global-table">
        <el-table :data="dataSource" @selection-change="handleSelectionChange">　
          <el-table-column type="selection" width="55" :selectable="isDisabled"> </el-table-column>
          <el-table-column label="N" width="60" fixed align="center"><template slot-scope="scope">{{renderNum(scope.$index, currentPage, pageSize)}}</template></el-table-column>
          <el-table-column prop="sn" label="流水号" width="240"></el-table-column>
          <el-table-column prop="amount" label="充值金额"></el-table-column>
          <el-table-column prop="invoiceAmount" label="已开票金额"></el-table-column>
          <el-table-column label="付款方式">
            <template slot-scope="scope">
              <div> {{ setPayType(scope.row.payType) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="creatorAccount" label="付款账号"></el-table-column>
          <el-table-column prop="transferTitle" label="对公转账抬头"></el-table-column>
          <el-table-column prop="invoiceStatus" label="状态">
            <template slot-scope="scope">
              <div> {{ setInvoiceStatus(scope.row.invoiceStatus) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.payTime">
                <div class="time">{{moment(scope.row.payTime).format("YYYY-MM-DD HH:mm:ss")}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="global-page">
        <el-pagination background @size-change="changePageSize" @current-change="changePage" :page-sizes="[15, 30, 45, 60]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage" :total="total"></el-pagination>
      </div>
    </div>
    <Fillbill :invoicingList="multipleSelection" :amount="invoiceAmount" :visible="invoicingDialogVisible" />
  </div>
</template>
<script>
import moment from 'moment'
import { httpAjax } from '@/api/ajax'
import { renderNum, getPageCurrent } from "@/api/config"
import { stateList } from "@/api/config"
import { getDistanceMonth, urlEncode } from "@/utils/util"
import Fillbill from "./components/fillbill"
import TopTitle from '@/components/TopTitle'
import { MODE_CONF } from '@/utils/config'
export default {
  name: "recordList",
  components: { Fillbill, TopTitle },
  data () {
    return {
      moment,
      renderNum,
      getPageCurrent,
      stateList,
      search: {},
      dataSource: [],
      tabIndex: '1',
      dateArr: '',
      currentPage: 1,
      total: 1,
      pageSize: 15,
      invoicingDialogVisible: false,
      invoiceAmount: 0,
      multipleSelection: [],
    }
  },
  watch: {
    dateArr (val) {
      this.search.startDate = val ? val[0] + ' 00:00:00' : ''
      this.search.endDate = val ? val[1] + ' 23:59:59' : ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    //  无法开票
    isDisabled (row) {
      if (row.payType === 5 || row.invoiceStatus == 1 || row.invoiceStatus == 2) {
        return 0
      }
      return 1
    },
    //  选择多条
    handleSelectionChange (val) {
      this.invoiceAmount = 0
      this.multipleSelection = val.map((n) => {
        return n.sn
      })
      val.map((n) => {
        this.invoiceAmount += (n.amount - n.invoiceAmount)
      })
    },
    //  申请开票
    handApplication () {
      if (this.multipleSelection.length > 0) {
        this.invoicingDialogVisible = true
      } else {
        this.$message({
          message: "请勾选流水号",
          type: "warning",
        })
      }
    },
    setInvoiceStatus (code) {
      try {
        let item = this.stateList.payStatus.filter((n) => n.value == code)
        return item[0].label || ''
      } catch (err) { }
    },
    setPayType (code) {
      try {
        let item = this.stateList.payType.filter((n) => n.value == code)
        return item[0].label || ''
      } catch (err) { }
    },
    searchData () {
      this.currentPage = 1
      this.getData()
    },
    getData () {
      httpAjax({
        url: '/services/recharge/list',
        method: "get",
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          ...this.search
        },
      }).then((response) => {
        if (response.success) {
          this.dataSource = response.data
          this.currentPage = response.pager.currentPage
          this.total = Number(response.pager.total)
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },
    //导出
    exporTables () {
      if (this.dateArr) {
        let num = getDistanceMonth(this.search.startDate, this.search.endDate)
        if (num >= 3) {
          this.$message({
            message: '最多允许导出3个月的数据，请重新选择日期!',
            type: "error",
          })
        } else {
          let token = localStorage.getItem('userToken')
          let obg = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.search
          }
          window.open(MODE_CONF.base_url + `/services/recharge/export?token=${token}${urlEncode(obg)}`)
        }
      } else {
        this.$message({
          message: '请选择交易时间',
          type: "error",
        })
      }
    },
    changePageSize (num) {
      this.pageSize = num
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    // 清空
    empty () {
      this.search = {}
      this.dateArr = null
    },
  }
};
</script>
 
<style scoped lang="less">
.recordList {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 20px;

  .search-box {
    min-height: 56px;
    background: #f7f7fa;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 24px;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .list-tab-page {
    overflow: hidden;
  }
  /deep/.el-form .el-form-item .el-form-item__label {
    line-height: 32px !important;
  }
}
.global-page {
  padding-bottom: 24px;
}

.export {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  cursor: pointer;
  padding-bottom: 16px;
  margin-right: 24px;
  ::v-deep .iconfont {
    font-size: 12px;
    display: inline-block;
    padding-right: 4px !important;
  }
}
</style>